(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/top-bar.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/top-bar.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const Icon = svs.ui.ReactIcon;
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
setGlobal('svs.tickets.next.components.NextTopBar', _ref => {
  let onClose = _ref.onClose,
    isSoundOn = _ref.isSoundOn,
    onSoundClick = _ref.onSoundClick,
    _ref$onInfoClick = _ref.onInfoClick,
    onInfoClick = _ref$onInfoClick === void 0 ? null : _ref$onInfoClick,
    trackingLabel = _ref.trackingLabel;
  const TopBarOverlay = svs.ticketgames.ticketUtility.components.TopBarOverlay;
  const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.components.useGameContext(),
    ticketInfo = _svs$ticketgames$tick.ticketInfo;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    guides = _useState2[0],
    setGuides = _useState2[1];
  const infoRef = useRef(null);
  const mounted = useRef(false);
  const Button = svs.ui.Button;
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    shouldShowOverlay = _useState4[0],
    setShouldShowOverlay = _useState4[1];
  const showDialog = svs.ticketgames.ticketUtility.utils.showDialog;
  const hasSound = ticketInfo.hasSound;
  const fetchGuides = svs.ticketgames.ticketUtility.utils.fetchGuides;
  const trackTopBarAction = svs.ticketgames.ticketUtility.utils.tracking.trackTopBarAction;
  useEffect(() => {
    mounted.current = true;
    (async () => {
      const guides = await fetchGuides(ticketInfo);
      mounted.current && setGuides(guides);
    })();
    return () => {
      mounted.current = false;
    };
  }, [ticketInfo]);
  const activeTabIndex = shouldShowOverlay ? -1 : 0;
  return React.createElement("div", {
    className: "padding-h-1 padding-top-2 gamelauncher-topbar"
  }, React.createElement(TopBarOverlay, {
    guides: guides,
    isActive: shouldShowOverlay,
    onCloseOverlay: () => {
      var _infoRef$current;
      setShouldShowOverlay(false);
      (_infoRef$current = infoRef.current) === null || _infoRef$current === void 0 || _infoRef$current.focus();
    },
    trackingLabel: trackingLabel
  }), React.createElement("div", {
    className: "ts-next-topbar-actions"
  }, React.createElement(Button, {
    className: "ts-top-bar-game-color ts-next-topbar-icon-btn qa-top-bar-pause",
    onClick: () => {
      trackTopBarAction('Spelpaus24', trackingLabel);
      svs.tur.pause24.checkLoggedIn();
    },
    size: 300,
    tabIndex: activeTabIndex
  }, React.createElement(Icon, {
    icon: "spelpaus",
    size: "100"
  })), React.createElement(Button, {
    className: "ts-top-bar-game-color ts-next-topbar-icon-btn qa-top-bar-self-test",
    onClick: e => {
      e.preventDefault();
      showDialog({
        type: 'selfTest',
        onClose
      });
      trackTopBarAction('Självtest', trackingLabel);
    },
    size: 300,
    tabIndex: activeTabIndex
  }, React.createElement(Icon, {
    icon: "self-test",
    size: "100"
  })), guides.length > 0 && React.createElement(Button, {
    "aria-label": "V\xE4nda lott",
    className: "ts-top-bar-game-color ts-next-topbar-icon-btn qa-top-bar-info",
    "data-testid": "info-top-bar",
    elemRef: infoRef,
    onClick: e => {
      e.preventDefault();
      trackTopBarAction('Vänd_lott', trackingLabel);
      if (onInfoClick) {
        onInfoClick();
        return;
      }
      setShouldShowOverlay(true);
    },
    size: 300,
    tabIndex: activeTabIndex
  }, React.createElement(Icon, {
    icon: "information",
    size: "100"
  })), hasSound && React.createElement(Button, {
    "aria-atomic": "true",
    "aria-label": "".concat(isSoundOn ? 'Ljud på' : 'Ljud av'),
    "aria-live": "polite",
    className: "ts-top-bar-game-color ts-next-topbar-icon-btn qa-top-bar-sound",
    "data-testid": "sound-top-bar",
    onClick: e => {
      e.preventDefault();
      onSoundClick();
      trackTopBarAction(isSoundOn ? 'Ljud_av' : 'Ljud_på', trackingLabel);
    },
    size: 300,
    tabIndex: activeTabIndex
  }, React.createElement(Icon, {
    icon: isSoundOn ? 'volyme-on' : 'volyme-off',
    size: "100"
  }))), React.createElement("div", {
    className: "ts-next-topbar-close-wrap"
  }, onClose && React.createElement(Button, {
    "aria-label": "Avsluta spelet",
    className: "ts-top-bar-game-color ts-next-topbar-close-btn qa-top-bar-close",
    "data-testid": "close-top-bar",
    onClick: e => {
      e.preventDefault();
      trackTopBarAction('Stäng', trackingLabel);
      onClose();
    },
    size: 300,
    tabIndex: activeTabIndex
  }, React.createElement("span", {
    className: "ts-next-topbar-close-icon"
  }, React.createElement(Icon, {
    icon: "close",
    size: "100"
  }), React.createElement("span", {
    className: "ts-next-topbar-close-label"
  }, "Avsluta")))));
});

 })(window);